import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dayRow", "timeInput"];

  clearHours(event) {
    const row = event.currentTarget.closest(
      '[data-business-hours-target="dayRow"]'
    );
    row
      .querySelectorAll('input[type="time"]')
      .forEach((input) => (input.value = ""));
  }

  copyHours(event) {
    const sourceRow = event.currentTarget.closest(
      '[data-business-hours-target="dayRow"]'
    );
    const openTime = sourceRow.querySelector('input[name*="[open]"]').value;
    const closeTime = sourceRow.querySelector('input[name*="[close]"]').value;

    this.dayRowTargets.forEach((row) => {
      if (row !== sourceRow) {
        row.querySelector('input[name*="[open]"]').value = openTime;
        row.querySelector('input[name*="[close]"]').value = closeTime;
      }
    });
  }

  applyToWeekdays(event) {
    const sourceRow = event.currentTarget.closest(
      '[data-business-hours-target="dayRow"]'
    );
    const openTime = sourceRow.querySelector('input[name*="[open]"]').value;
    const closeTime = sourceRow.querySelector('input[name*="[close]"]').value;

    this.dayRowTargets.forEach((row) => {
      const dayName = row.dataset.day.toLowerCase();
      if (
        ["monday", "tuesday", "wednesday", "thursday", "friday"].includes(
          dayName
        )
      ) {
        row.querySelector('input[name*="[open]"]').value = openTime;
        row.querySelector('input[name*="[close]"]').value = closeTime;
      }
    });
  }
}
